import { Controller } from 'stimulus'
import VenoBox from 'venobox'

export default class GalleryController extends Controller {
  connect() {
    console.log('Gallery controller connected')
    this.gallery = new VenoBox({
        selector: '.js-gallery-elem',
        infinigall: true
    });

    console.log(this.gallery)
  }

  disconnect() {
    this.gallery.destroy()
  }
}